import { FC, useEffect, useState } from 'react'
import css from './index.module.less'
import { AutoCenter, DotLoading, List, TabBar, Tabs } from 'antd-mobile'
import { getCateListApi, getQuestionListApi } from '@/api/home'
import { actionTypes, useStoreDispatch, useStoreState } from '@/store'
import { useUpdateEffect } from '@/hooks/useUpdateEffect'
import { PageLoading } from '@/components/PageLoading'
import InfiniteScrollTem from '@/components/InfiniteScrollContent'
import { useNav } from '@/hooks/useNav'
import { getLngToApi } from '@/utils/getLng'

export const QuestionList: FC = props => {
  const [activeCateId, setActiveCateId] = useState<string>();
  const [cateList, setCateList] = useState([]);
  const [questionList, setQuestionList] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, size: 20 });
  const { centerConfig, pageLoading }: any = useStoreState();
  const dispatch = useStoreDispatch()
  const [loading, setLoading] = useState(false);

  // 初始化获取分类列表
  useEffect(() => {
    const getCateList = async () => {
      process.env.REACT_APP_IDN_ENV !== 'hw' && dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: true });
      const res = await getCateListApi({ centerId: centerConfig.id, language: getLngToApi() }).finally(() => dispatch({ type: actionTypes.SET_PAGE_LOADING, payload: false }))
      if (res?.code === 0) {
        setCateList(res.data);
        setActiveCateId(`${res.data[0]?.id||0}`);
      }
    }
    getCateList();
  }, [])

  // 获取问题列表
  const getQuestionList = async () => {
    const res = await getQuestionListApi({
      centerId: centerConfig.id,
      askId: activeCateId,
      language: getLngToApi(),
      ...pagination,
    }).finally(() => setLoading(false))
    if (res?.code === 0) {
      setQuestionList(prevState => ([...prevState, ...res.data.records]));
      setPagination(prevState => ({ ...prevState, current: prevState.current + 1 }));
      setHasMore(res.data.current < res.data.pages);
    }
  }
  // 改变选中分类则重置分页并获取问题列表
  useUpdateEffect(() => {
    setLoading(true)
    setQuestionList([]);
    getQuestionList();
  }, [activeCateId])

  const onTabClick = value => {
    setActiveCateId(value);
    setPagination(prevState => ({ ...prevState, current: 1 }));
  }

  const { nav } = useNav();
  const onClick = deployId => nav(`/question-detail/${deployId}`);


  if (pageLoading) return <PageLoading />

  if(process.env.REACT_APP_IDN_ENV === 'hw' && cateList.length === 0){
    return null
  }

  return (
    <div className={css.Page}>
      {
        process.env.REACT_APP_IDN_ENV === 'hw' ?
        <Tabs className={css.Tabs} activeKey={activeCateId} onChange={onTabClick}>
          {cateList.map(item => (
            <Tabs.Tab title={item.askName} key={item.id} />
          ))}
        </Tabs> :
        <TabBar className={css.TabBar} activeKey={activeCateId} onChange={onTabClick}>
          {cateList.map(item => (
            <TabBar.Item key={item.id} title={item.askName} />
          ))}
        </TabBar>
      }

      {loading ? <AutoCenter><DotLoading color={'primary'} /></AutoCenter> : (
        <>
          <List className={css.List}>
            {questionList.map(item => (
              <List.Item key={item.id} onClick={() => onClick(item.id)}>{item.title}</List.Item>
            ))}
          </List>
          <InfiniteScrollTem loadMore={getQuestionList} hasMore={hasMore} />
        </>
      )}

    </div>
  )
}
